import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { PracticeArea } from '../../../../backend/src/user/practice-area';
import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

export const useUpdateOwnPracticeArea = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<void, Error, PracticeArea>({
    mutationFn: async (practiceArea: PracticeArea) => {
      const response = await fetch(
        `${APIBaseChronos}/api/user`,
        getFetchConfig({ method: FetchMethod.PATCH, data: { practiceArea } }),
      );

      if (!response.ok) throw new Error('Failed to update practice area');
    },
    onSuccess: () => {
      toast.success('Practice area updated');
      queryClient.invalidateQueries([QueryEntity.User]);
    },
    onError: () => {
      toast.error('Failed to update practice area');
    },
  });
};
